import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ReviewCard = ({ name, country, image, rating, review }) => (
  <div className="review-card p-3">
    <div className="card border-0 shadow rounded-4 text-center p-4 h-100">
      <h6 className="fw-bold">{name}</h6>
      <div className="mb-2 mt-1">
        {[...Array(rating)].map((_, i) => (
          <i key={i} className="fa-solid fa-star text-warning me-1"></i>
        ))}
      </div>
      <p className="text-muted fst-italic">"{review}"</p>
    </div>
  </div>
);

const Testimonialskeyword = ({ reviews }) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 1000,
    slidesToShow: 2, // Show 2 slides by default
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 576, // On small devices
        settings: {
          slidesToShow: 1 // Show only 1 slide
        }
      }
    ]
  };

  return (
    <section
      className="py-5"
      style={{
        background: "url(/img/reviewbg.png) no-repeat center center / cover"
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our Customers Say About Skyline Cabs</h2>
         
        </div>
        <Slider {...settings}>
          {reviews.map((item, idx) => (
            <ReviewCard key={idx} {...item} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonialskeyword;
